"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPositionsTPSLPairMap = exports.usePositionTPSLPairs = exports.setTPSLOrdersInvalidState = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const CustomTPSLProvider_1 = require("../../../CustomOrders/CustomTPSLProvider");
const interface_1 = require("../../../../interface");
const react_1 = require("react");
const TPSLUtils_1 = require("./TPSLUtils");
const CustomTriggersProvider_1 = require("../../../CustomOrders/CustomTriggersProvider");
const const_1 = require("./../../../../component/const");
function mergeTPSLOrders(tpOrders, slOrders) {
    const orderPairs = [];
    let index = 0;
    while (tpOrders.length > index || slOrders.length > index) {
        orderPairs.push({
            tpOrder: tpOrders[index],
            slOrder: slOrders[index],
            id: `tp-sl-pair-${index}`,
        });
        index++;
    }
    return orderPairs;
}
/**
 * 更新传入的止盈止损列表，并设置不可用状态
 * 注意orders必须是排序后的
 */
function setTPSLOrdersInvalidState(positionQty, orders) {
    if (!orders) {
        return orders;
    }
    const positionQtyD = new trade_utils_lib_1.SafeDecimal(positionQty).abs();
    let remainQty = positionQtyD;
    let isInvalid = false;
    const newOrders = [];
    (orders || []).forEach((o) => {
        const tpSlOrder = Object.assign({}, o);
        if (isInvalid) {
            tpSlOrder.invalid = true;
        }
        else {
            const { type, amount } = o;
            // 当平全部时，直接平掉所有当前剩余的量
            const closeQty = type === interface_1.CustomOrderType.CLOSE ? remainQty : amount;
            remainQty = remainQty.sub(new trade_utils_lib_1.SafeDecimal(closeQty));
            if (remainQty.lte(0)) {
                isInvalid = true;
            }
            // 计算当前的占比
            tpSlOrder.qtyPercent = new trade_utils_lib_1.SafeDecimal(closeQty).div(positionQtyD).mul(100).toFixed(2);
            tpSlOrder.invalid = false;
        }
        newOrders.push(tpSlOrder);
    });
    return newOrders;
}
exports.setTPSLOrdersInvalidState = setTPSLOrdersInvalidState;
/**
 * 将全部平仓订单和部分平仓订单分离
 * @param items 未分离的订单
 * @returns [全部平仓订单, 部分平仓订单]
 */
function classifyOrders(items) {
    var _a;
    const initValue = [[], []];
    return ((_a = items === null || items === void 0 ? void 0 : items.reduce((pre, cur) => {
        if (cur.type === interface_1.CustomOrderType.CLOSE) {
            pre[0].push(cur);
        }
        else {
            pre[1].push(cur);
        }
        return pre;
    }, initValue)) !== null && _a !== void 0 ? _a : initValue);
}
function batchCancel(orders) {
    return () => {
        const needCancel = orders.slice(0, 10).map((e) => {
            return { triggerId: e.trigger_id, symbol: e.symbol, accountType: const_1.FutureAccountType };
        });
        return (0, CustomTriggersProvider_1.batchCancelTriggerOrder)(needCancel);
    };
}
/**
 * 获取仓位关联的止盈止损（成对出现）
 */
function usePositionTPSLPairs(props, active = true) {
    const { positionId, positionQty } = props;
    const _a = (0, CustomTPSLProvider_1.usePositionAssociateTPSLOrder)(positionId), { allTpOrders: _tpOrders, allSlOrders: _slOrders } = _a, others = __rest(_a, ["allTpOrders", "allSlOrders"]);
    const allTpOrders = (0, react_1.useMemo)(() => setTPSLOrdersInvalidState(positionQty, _tpOrders), [_tpOrders, positionQty]);
    const allSlOrders = (0, react_1.useMemo)(() => setTPSLOrdersInvalidState(positionQty, _slOrders), [_slOrders, positionQty]);
    // 全部平仓订单和部分平仓订单
    const V2Data = (0, react_1.useMemo)(() => {
        // 全仓止盈订单，分仓止盈订单
        const [allCloseTpOrders, allAmountTpOrders] = classifyOrders(allTpOrders);
        // 全仓止损订单，分仓止损订单
        const [allCloseSlOrders, allAmountSlOrders] = classifyOrders(allSlOrders);
        // 全仓Pair订单
        const allClosePairOrders = mergeTPSLOrders(allCloseTpOrders, allCloseSlOrders);
        // 分仓Pair订单
        const allAmountPairOrders = mergeTPSLOrders(allAmountTpOrders, allAmountSlOrders);
        // 全仓全部订单
        const allCloseOrders = allCloseTpOrders.concat(allCloseSlOrders);
        // 分仓全部订单
        const allAmountOrders = allAmountTpOrders.concat(allAmountSlOrders);
        // 全仓全部撤销
        const showCloseDeleteAll = allCloseOrders.length > 0;
        // 分仓全部撤销
        const showAmountDeleteAll = allAmountOrders.length > 0;
        return {
            allCloseTpOrders,
            allAmountTpOrders,
            allCloseSlOrders,
            allAmountSlOrders,
            allClosePairOrders,
            allAmountPairOrders,
            allCloseOrders,
            allAmountOrders,
            showCloseDeleteAll,
            showAmountDeleteAll,
        };
    }, [allSlOrders, allTpOrders]);
    const { pairOrders, allOrders } = (0, react_1.useMemo)(() => ({
        pairOrders: mergeTPSLOrders(allTpOrders || [], allSlOrders || []),
        allOrders: (allTpOrders || []).concat(allSlOrders || []),
    }), [allSlOrders, allTpOrders]);
    // 全仓批量撤销
    const cancelAllCloseOrders = (0, react_1.useCallback)(batchCancel(V2Data.allCloseOrders), [V2Data.allCloseOrders]);
    // 分仓批量撤销
    const cancelAllAmountOrders = (0, react_1.useCallback)(batchCancel(V2Data.allAmountOrders), [V2Data.allAmountOrders]);
    const cancelAllOrders = (0, react_1.useCallback)(() => {
        const needCancel = allOrders.slice(0, 10).map((e) => {
            return { triggerId: e.trigger_id, symbol: e.symbol, accountType: const_1.FutureAccountType };
        });
        return (0, CustomTriggersProvider_1.batchCancelTriggerOrder)(needCancel);
    }, [allOrders]);
    const showDeleteAll = allOrders.length > 0;
    return Object.assign(Object.assign(Object.assign({ allTpOrders,
        allSlOrders,
        pairOrders }, others), V2Data), { showDeleteAll,
        cancelAllOrders,
        cancelAllCloseOrders,
        cancelAllAmountOrders });
}
exports.usePositionTPSLPairs = usePositionTPSLPairs;
function getPositionsTPSLPairMap(orders) {
    const map = new Map();
    if (!orders || !orders.length) {
        return map;
    }
    const tempMap = new Map();
    orders.forEach((order) => {
        const { trigger_position_id = "" } = order;
        const mode = TPSLUtils_1.TPSLUtils.getOrderTPSLMode(order);
        let pairData = tempMap.get(trigger_position_id);
        if (!pairData) {
            tempMap.set(trigger_position_id, { tpList: [], slList: [] });
        }
        pairData = tempMap.get(trigger_position_id);
        if (pairData) {
            if (mode === "tp") {
                pairData.tpList.push(order);
            }
            else {
                pairData.slList.push(order);
            }
        }
    });
    for (const [positionId, { slList, tpList }] of tempMap.entries()) {
        const newSlList = (0, CustomTPSLProvider_1.sortTPSLOrders)("sl", slList);
        const newTpList = (0, CustomTPSLProvider_1.sortTPSLOrders)("tp", tpList);
        map.set(positionId, {
            tpOrders: newTpList,
            slOrders: newSlList,
            positionId,
        });
    }
    return map;
}
exports.getPositionsTPSLPairMap = getPositionsTPSLPairMap;
